import type { IdeaStatusViewInlineProps } from '../types';

const defaultViewProps: Partial<IdeaStatusViewInlineProps> = {
  showIdeaCount: true
};

export default defaultViewProps;
